import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { ConversaMensagem } from 'app/shared/interfaces/conversa-mensagem';

/**
 * Histórico de WhatsApp do cliente — somente leitura.
 *
 * Mostra o que já foi conversado antes de atender. Não envia mensagem: responder continua no
 * WhatsApp, e um campo de envio aqui daria a impressão de um atendimento que o ERP não faz.
 */
@Component({
  selector: 'app-cadastro-conversa-popup',
  templateUrl: './cadastro-conversa-popup.component.html',
  styleUrls: ['./cadastro-conversa-popup.component.scss']
})
export class CadastroConversaPopupComponent implements OnInit {

  layoutConf: any;
  cadastro: Cadastro;

  mensagens: ConversaMensagem[] = [];
  carregando = true;
  page = 1;
  pageSize = 25;
  length = 0;
  pageSizeOptions: number[] = [25, 50];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroConversaPopupComponent>,
    private layout: LayoutService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;
    this.carregar(this.page, this.pageSize);
  }

  carregar(page: number, pageSize: number): void {
    if (!this.cadastro?.id) {
      this.carregando = false;
      return;
    }
    this.carregando = true;
    this.cadastroService.getPageConversa(page, pageSize, this.cadastro.id.toString()).subscribe({
      next: pagina => {
        this.carregando = false;
        // A API devolve da mais recente para a mais antiga (para paginar o fim da conversa);
        // a leitura é natural na ordem cronológica, então inverte para exibir.
        this.mensagens = [...(pagina?.content ?? [])].reverse();
        this.length = pagina?.totalElements ?? 0;
        this.pageSize = pagina?.size ?? pageSize;
      },
      error: () => {
        this.carregando = false;
        this.mensagens = [];
      }
    });
  }

  mudarPagina(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.carregar(event.pageIndex + 1, event.pageSize);
  }

  close(): void {
    this.dialogRef.close();
  }
}
